<template>
  <div class="invoice_container" style="width:1400px;margin: 0 auto;margin-bottom: 20px;min-height:calc(100vh - 500px)">
    <div class="breadcrumb" style="margin-bottom:20px">
      <Breadcrumb separator=">">
        <BreadcrumbItem to="/"> {{ $t("nav.home") }}</BreadcrumbItem>
        <BreadcrumbItem>智能归类 </BreadcrumbItem>
     
      </Breadcrumb>
    </div>
    <div class="query_box boxshadow1">
      <div class="query_conf">
        <div class="slogo-title">智能归类</div>
        <div class="query_conf_items">
          <div class="query_conf_wrap">
            <div class="query_conf_item">
              <div class="query_conf_item_wrap">
                <div class="title">商品描述</div>
                <div class="value"><Input v-model.trim="conf.querykey" placeholder="输入商品描述" clearable></Input></div>
              </div>
            </div>
            <div class="query_conf_item">
              <div class="query_conf_item_wrap">
                <div class="title">商品编码</div>
                <div class="value"><Input v-model.trim="conf.hs" placeholder="输入商品编码" clearable></Input></div>
              </div>
            </div>
           
          </div>
        </div>

    

        <div class="btns_wrap">
          <Button type="primary" class="btn search" @click.prevent="searchHandle"><span>搜索</span></Button>
         
        </div>
      </div>
    </div>

    <div class="query_result boxshadow1" style="position:relative;">
      
      <div class="content">
     
        <div class="table-containter">
          <div class="table-wrap">
            <Table :columns="query.columns" :data="query.list" no-data-text="暂无记录"></Table>
          </div>
        </div>
        <div class="pager-wrap">
          <Page :total="query.total" :current="currentPageNumber" :page-size="pageSize" size="small" @on-change="getQueryList"></Page>
          <div class="pager-elevator">
            <span>前往</span><InputNumber :max="totalPage || 1" :min="1" :step="1" size="small" v-model="currentPage" @on-blur	="onElevatorBlur"></InputNumber><span>页</span><Button @click="onElevator">确定</Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/layout/Loader'
import { saveAs } from 'file-saver'

export default {
  name: 'classify',
  components: { Loader },
  props: ['mh'],
  data () {
    return {
      conf: {
        hs: '',
        querykey: '',
        
      },
      isRun: false,
      runNum: 0,
      ftaData: [],
      batchData: [],
      areaData: [],
      statData: {},
      uploading: false,
      exporting: false,
      dateRange: '',
      isShowModalLoader: false,
      searching: false,
      pageSize: 10,
      currentPage: 1,
      currentPageNumber: 1,
      totalPage: 1,
      query: {
        total: 0,
        columns: [
          {title: '商品描述', key: 'hsDescription', align: 'center', minWidth: 240, ellipsis: true, render: (h, params) => {
            return h('span', { attrs: {title: params.row.hsDescription} }, params.row.hsDescription || '-')
          }},
          {title: '商品编码', key: 'hsCode', align: 'center', minWidth: 150, ellipsis: true, render: (h, params) => {
            return h('span', { attrs: {title: params.row.hsCode} }, params.row.hsCode || '-')
          }},
          {title: '品名', key: 'dataWord', align: 'center', minWidth: 200, ellipsis: true, render: (h, params) => {
            return h('span', { attrs: {title: params.row.dataWord} }, params.row.dataWord || '-')
          }},
          {title: '同词占比', key: 'ratio', align: 'center', minWidth: 200, ellipsis: true, render: (h, params) => {
            return h('span', { attrs: {title: params.row.ratio} }, params.row.ratio|| '-')
          }},
          {title: '关键词与品名匹配度', key: 'matchingRate', align: 'center', minWidth: 200, ellipsis: true, render: (h, params) => {
            return h('span', { attrs: {title: params.row.matchingRate} }, params.row.matchingRate || '-')
          }},
          { title: '操作', key: 'action', align: 'center', fixed: 'right', width: 90, render: (h, params) => {
            return h('div', { class: 'opr' }, [
              h('a', {class: 'row-detail', on: {
                click: event => {
                  event.stopPropagation()
                  event.preventDefault()
                  this.$router.push({path: '/classify/detail', query: { hsCode: params.row.hsCode,sourceid:params.row.id }})
                }
              }}, '详情')
            ])
          }}
        ],
        list: []
      },
    }
  },
 
  methods: {
    onElevator () {
      this.getQueryList(this.currentPage || 1)
    },
    resetHandle () {
      this.conf = {currentPage: 1, pagecount: this.pageSize,hs:'',querykey:''}

    },
    onElevatorBlur () {
      if (!this.currentPage) {
        this.currentPage = 1
      } else if (this.currentPage > this.totalPage) {
        this.currentPage = this.totalPage
      }
    },
  
  
   
    getQueryList(page = 1) {
      if (this.isShowModalLoader) return
      this.isShowModalLoader = true
      this.searching = true
      this.$Loading.start()
      this.currentPageNumber = page
      this.currentPage = page
      this.$api.classify.getList(this._.assign({currentPage: page || 1, pagecount: this.pageSize,hs:this.conf.hs,querykey:this.conf.querykey} ), {
        success: response => {
          this.$Loading.finish()
          if (response.data.code === 200) {
          
            this.query.list = response.data.data.classHistoryResult || []
            this.query.total = response.data.data.total || 0
            this.totalPage = response.data.data.pageCount || 0
          } else {
            this.$Message.warning({content: this.$t('common.codeError'), duration: 1.5, closable: true})
          }
          this.isShowModalLoader = false
          this.searching = false
        },
        error: errorMsg => {
          this.isShowModalLoader = false
          this.searching = false
          this.$Message.error({content: this.$t('common.tryAgain'), duration: 1.5, closable: true})
          this.$Loading.error()
        }
      })
    },
  
    searchHandle () {
      if (!this.conf.querykey) {
        this.$Message.info({content: '商品描述不能为空', duration: 1.5, closable: true})
      } else {
        this.getQueryList(1)
       
      }
    },
 
    resetHandle () {
      this.conf = {querykey: '', hs: ''}
      this.dateRange = ''
    },
  
   
 
   
  }
}
</script>

<style scoped>
.invoice_container{
  background-color: #fff;
  padding: 5px 0 0;
}
.query_box{
  margin-bottom: 30px;
}
.query_result{
  padding: 6px 18px 24px;
}
.query_conf{
  font-size: 14px;
  padding: 18px 18px 22px;
}
.slogo-title{
  color: #323232;
  font-weight: bold;
  font-size: 16px;
  padding: 0 18px 10px 0;
}
.query_conf_title{
  color: #999;
  font-size: 14px;
  margin-bottom: 6px;
  padding-left: 16px;
  background: url("~@/assets/images/home/rate2.png") no-repeat 0 center transparent;
  background-size: 11px;
}
.query_conf_title.keys{
  background: url("~@/assets/images/home/pro2.png") no-repeat 0 5px transparent;
  background-size: 11px;
}
.query_conf_wrap{
  margin-left: -10px;
  margin-right: -10px;
  display: flex;
  flex-wrap: wrap;
}
.query_conf_item{
  width: 20%;
}
.query_conf_item_wrap{
  margin: 0 10px 14px;
}
.query_conf_item_wrap .title{
  font-size: 16px;
  margin-bottom: 4px;
}
.query_conf_item_wrap >>> .ivu-input,
.query_conf_item_wrap >>> .ivu-select-selection,
.query_conf_item_wrap >>> .ivu-input-number,
.query_conf_item_wrap >>> .ivu-select-input{
  border-color: #b1b1b1;
  border-radius: 2px;
  font-size: 16px;
}
.query_conf_item_wrap >>> .ivu-tag-text{
  font-size: 16px;
}
.query_conf_item_wrap >>> .ivu-input-number{
  height: 30px;
  box-sizing: content-box;
  line-height: 30px;
}
.query_conf_item_wrap >>> .ivu-input-number-input{
  height: 30px;
  line-height: 30px;
}
.query_conf_item_wrap >>> .ivu-input-number-input::placeholder{
  font-size: 16px;
}
.query_conf_item_wrap >>> .ivu-select-selected-value{
  font-size: 16px !important;
}
.query_conf_item_wrap >>> .ivu-select-placeholder{
  font-size: 16px !important;
}
.query_conf_item_wrap >>> .ivu-select-item{
  font-size: 16px !important;
}
.btns_wrap{
  height: 32px;
  margin-top: 10px;
}
.btn{
  max-width: 180px;
  width: 18.4%;
  border: 1px solid #8892f3;
  border-radius: 3px;
  height: 32px;
  float: left;
  font-size: 16px;
  text-align: center;
  cursor: pointer;
  position: relative;
  box-sizing: border-box;
  letter-spacing: 2px;
}
.btn span{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.btn.search{
  background-color: #8892f3;
  color: #fff;
}
.btn.ivu-btn-loading{
  cursor: default;
}
.btn.ivu-btn-loading span{
  position: static;
  transform: none;
}
.btn.reset{
  background-color: #fff;
  color: #8892f3;
  margin-left: 20px;
}
.btn.reset[disabled]{
  color: #bbbec4;
  border-color: #dddee1;
  cursor: default;
}
.opr_acitons{
  padding: 16px 18px;
  margin-bottom: 30px;
}
.actions{
  position: relative;
}
.actions .add{
  border: 1px solid #bc8cf0;
  background-color: #bc8cf0;
  color: #fff;
}
.upload-input{
  display: none;
}
.actions >>> .ivu-btn{
  border-radius: 2px;
  width: 65px;
  font-size: 16px;
}
.actions >>> .ivu-btn .ivu-icon-ios-search{
  background: url("~@/assets/images/home/add.png") 0 center no-repeat transparent;
  background-size: 14px;
  width: 14px;
  height: 14px;
  position: relative;
  top: 2px;
}
.actions >>> .upload.ivu-btn .ivu-icon-ios-search{
  background-image: url("~@/assets/images/home/export.png");
}
.actions >>> .del.ivu-btn .ivu-icon-ios-search{
  background-image: url("~@/assets/images/home/del.png");
}
.actions >>> .ivu-btn>.ivu-icon+span, .ivu-btn>span+.ivu-icon{
  margin-left: 2px;
}
.actions >>> .ivu-btn .ivu-icon-ios-search:before{
  content: "";
}
.actions .upload{
  border: 1px solid #8892f3;
  background-color: #8892f3;
  color: #fff;
  padding: 2px 0;
  font-size: 14px;
}
.actions .del{
  border: 1px solid #8ac3fa;
  background-color: #8ac3fa;
  color: #fff;
  margin-right:20px;
}
.actions .copy{
  border-color: #0774b5;
  color: #0774b5;
}
.actions .copy[disabled]{
  color: #ccc;
  border-color: #ccc;
}
.actions .copy >>> .ivu-icon{
  font-size: 20px;
  position: relative;
  top: 2px;
}
.actions .right_action{
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0;
}
.actions .right_action .cert_btn{
  color: #1F8AFD;
  background: url("~@/assets/images/coo/icon_zhengshuguanli.png") 0 center no-repeat transparent;
  background-size: 13px auto;
  padding-left: 16px;
}
.actions .right_action .dw_tpl{
  display: inline-block;
  margin-left: 10px;
  font-size: 16px;
}
.actions .right_action .dw_tpl:hover{
  text-decoration: underline;
}
.content{
  margin-top: 20px;
  position: relative;
}
.table-containter{
  position: relative;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 3px;
  margin-top: 10px;
}
.table-wrap{
  width: 100%;
  border: 1px solid #ccc;
}
.table-wrap >>> .ivu-table-wrapper{
  /* width: 2300px; */
}
.table-wrap >>> .opr{
  white-space: nowrap;
}
.table-wrap >>> .ivu-table-body tr:nth-child(even) td{
  /* background-color: #eaf7ff; */
}
.table-wrap >>> .ivu-table:before, .table-wrap >>> .ivu-table:after{
  background-color: #eaf7ff;
}
.table-wrap >>> .ivu-table-overflowX{
  /* max-height: calc(100vh - 30vh); */
}
.content >>> .ivu-table-wrapper{
  border: 0 none;
}
.content >>> .ivu-table{
  color: #686765;
}
.content >>> .ivu-table th{
  background-color: #fff;
  font-size: 14px;
  font-weight: bold;
  border-color: #ccc;
  white-space: nowrap;
  border-bottom-width: 0.5px;
  border-right: 0.5px solid #ccc;
  color: #333;
}
.content >>> .ivu-table th span{
  white-space: nowrap;
  font-size:16px
}
.content >>> .ivu-table td{
  font-size: 16px;
  border-width: 0;
  border-right: 0.5px solid #ccc;
  border-bottom: 0.5px solid #ccc;
}
.content >>> .ivu-table .ivu-checkbox-wrapper{
  margin-right: 0;
}
.content >>> .ivu-table .tb_select .ivu-table-cell{
  padding-right: 0;
}
.content >>> .ivu-table .tb_company .ivu-table-cell{
  padding-left: 0;
}
.content >>> .ivu-table .opr a.line2:after{
  bottom: 0;
}
.content >>>.ivu-table-cell-ellipsis{
  font-size:16px
}
.ivu-page{
  margin-top: 20px;
  margin-bottom: 16px;
  text-align: right;
}
.ivu-page >>> a{
  font-size: 16px;
}
.ivu-page >>> a:hover{
  color: #0774b5;
}
.ivu-page >>> .ivu-page-prev a, .ivu-page >>> .ivu-page-next a{
  font-size: 22px;
}
.ivu-page >>> .ivu-page-item{
  margin: 0 5px;
}
.ivu-page >>> .ivu-page-item-active{
  background-color: #0774b5;
  border-color: #0774b5;
}
.ivu-page >>> .ivu-page-total{
  font-size: 16px;
}
.ivu-page >>> .ivu-page-options-elevator{
  font-size: 16px;
}
.ivu-page >>> .ivu-page-options-elevator input{
  font-size: 16px;
}
.ivu-page >>> .ivu-page-item a, .ivu-page >>> .ivu-page-next a, .ivu-page >>> .ivu-page-prev a{
  color: #8892f3;
}
.ivu-page >>> .ivu-page-disabled a{
  color: #999;
}
.ivu-page >>> .ivu-page-item-active{
  background-color: transparent;
  border: 0 none;
}
.ivu-page >>> .ivu-page-item-active a{
  color: #333;
}
.pager-wrap .ivu-page >>> .ivu-page-prev .ivu-icon-ios-arrow-left,
.pager-wrap .ivu-page >>> .ivu-page-next .ivu-icon-ios-arrow-right{
  position: relative;
  top: -3px;
}
.ivu-page >>> .ivu-page-prev .ivu-icon-ios-arrow-left::before{
  content: "上一页";
  font-size: 16px;
}
.ivu-page >>> .ivu-page-next .ivu-icon-ios-arrow-right::before{
  content: "下一页";
  font-size: 16px;
}
.ivu-page >>> .ivu-page-item-jump-next a, .ivu-page >>> .ivu-page-item-jump-prev a,
.ivu-page >>> .ivu-page-item-jump-next:after, .ivu-page >>> .ivu-page-item-jump-prev:after{
  color: #8892f3;
}
.pager-wrap{
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.pager-elevator{
  margin-left: 20px;
  font-size: 16px;
  display: flex;
  align-items: center;
}
.pager-elevator >>> .ivu-input-number{
  margin: 0 10px;
  width: 48px;
  font-size: 16px;
}
.pager-elevator >>> .ivu-input-number-handler-wrap{
  display: none;
}
.pager-elevator >>> .ivu-btn{
  background-color: #8892f3;
  border-color: #8892f3;
  color: #fff;
  margin-left: 10px;
  padding: 3px 8px;
  border-radius: 2px;
  font-size: 13px;
}
.ac_pager >>> .ivu-page{
  margin: 0;
}
.ac_pager >>> .ivu-page-item,
.ac_pager >>> .ivu-page-item-jump-prev,
.ac_pager >>> .ivu-page-item-jump-next{
  display: none;
}
.ac_pager >>> .ivu-page-prev .ivu-icon-ios-arrow-left::before,
.ac_pager >>> .ivu-page-next .ivu-icon-ios-arrow-right::before{
  font-size: 14px;
}
.ac_c1,.ac_c2,.ac_c3,.ac_c4{
  display: flex;
  align-items: center;
}
.ac_c1{
  justify-content: flex-end;
}
.ac_cc .title{
  color: #555;
  font-size: 16px;
  padding-right: 10px;
}
.ac_cc .value{
  background-color: #bc8cf0;
  color: #fff;
  padding: 2px 8px;
  font-size: 16px;
  min-width: 50px;
  text-align: center;
}
.ac_c2, .ac_c3, .ac_c4{
  justify-content: center;
}
.ac_c2 .value{
  background-color: #ffa799;
}
.ac_c3 .value{
  background-color: #8ac3fa;
}
.dw_tpl{
  font-size: 14px;
  white-space: nowrap;
  position: relative;
  left: 16px;
  color: #8892f3;
}
.dw_tpl:hover{
  color: #333;
}
.export_btn{
  margin-left: 20px;
  border: 1px solid #ffa799;
  background-color: #ffa799;
  color: #fff;
  font-size: 16px;
  border-radius: 3px;
  height: 32px;
  width: 100px;
}
.export_btn >>> .ivu-icon-ios-search{
  background-image: url("~@/assets/images/home/import.png");
  background-size: 14px;
  position: relative;
  top: 0 !important;
  width: 14px;
  height: 14px;
}
.export_btn >>> .ivu-icon-ios-search::before{
  content: "";
}
.export_btn span,
.export_btn >>> .ivu-icon{
  position: relative;
  top: -2px
}
.btns_wrap >>> .ivu-tooltip{
  position: relative;
  top: 3px;
  margin-left: 10px;
}
.btns_wrap >>> .svg-icon{
  font-size: 20px;
}
.table-wrap >>> .row-detail{
  font-size: 16px;
  color: #0774b5;
}
.table-wrap >>> .row-detail:hover{
  color: #055f94;
}
</style>


// WEBPACK FOOTER //
// src/components/Classify/ClassifyList.vue